// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ripple from 'vuetify/lib/directives/ripple'
import fi from 'vuetify/lib/locale/fi'

Vue.use(Vuetify, {
  directives: { ripple }
})

const theme = {
  primary: '#2C5697',
  secondary: '#A05EB5',
  accent: '#00A3E0',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: { expand: 'mdi-menu-down' },
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  lang: {
    locales: {fi},
    current: 'fi'
  }
})
